import { ValidationRule } from "@vuelidate/core";
import { required, helpers, minLength } from "@vuelidate/validators";
import { i18n } from "@/plugins/i18n";

const registrationNumberRegExp = new RegExp(
  "^(" +
    "AT(T|FN)\\d{3,6}[a-z]|" + // Austria
    "ATAT-ZVR-\\d{9}|" + // Austria
    "BE\\d{10}|" + // Belgium
    "BG\\d{9}|" + // Bulgaria
    "CY(C|P|HE)\\d{1,8}|" + // Cyprus
    "CZ[0-9\\s]{8,10}|" + // Czech Republic
    "DE[A-Z]{2,3}\\s\\d{1,6}[A-Z]{0,5}(-[A-Z]{1}\\d{4})?|" + // Germany
    "DK\\d{8}|" + // Denmark
    "EE\\d{8}|" + // Estonia
    "GR\\d{12}|" + // Greece
    "ES[A-Z0-9]\\d{7}[A-Z0-9]|" + // Spain
    "FI[0-9-]{8,10}|" + // Finland
    "FR(\\d{1,14}(-\\d{1,14})*)|" + // France
    "FRW\\d{9}|" + // France
    "HR\\d{9}|" + // Croatia
    "HU(\\d{1,10}(-\\d{1,10})*)|" + // Hungary
    "IE\\d{1,7}|" + // Ireland
    "IT\\d{11}|" + // Italy
    "IT[A-Z]{2}\\d{6,7}|" + // Italy
    "LT\\d{6,9}|" + // Lithuania
    "LU[A-Z]{1}\\d{5,7}|" + // Luxembourg
    "LV\\d{11}|" + // Latvia
    "MTC\\s\\d{4,6}|" + // Malta
    "NL\\d{8}|" + // Netherlands
    "PL\\d{9,10}|" + // Poland
    "PT\\d{9}|" + // Portugal
    "RO[A-Z]{1}\\d{2}/[0-9]{1,9}/[0-9]{4}|" + // Romania
    "SE(\\d{1,10}(-\\d{1,10})*)|" + // Sweden
    "SI\\d{10}|" + // Slovenia
    "SK\\d{8}|" + // Slovakia
    "GB\\d{6,7}|" + //United Kingdom
    "GB\\w{8}" + //United Kingdom
    ")$",
  "i", // Case-insensitive
);

const containsNumber = (value: string) => /\d/.test(value);
const containsUppercase = (value: string) => /[A-Z]/.test(value);
const containsLowercase = (value: string) => /[a-z]/.test(value);
export const isRegistrationNumber = (country: string, registrationNumber: string) =>
  registrationNumberRegExp.test(`${country}${registrationNumber}`);

const passwordValidationMessage =
  "Passwords must be at least 8 characters long, contain at least one number, one uppercase letter, and one lowercase letter.";

const siteNameRegex = helpers.regex(/^[a-zA-Z0-9 _-]+$/);
// \w matches any word character (alphanumeric and underscore).
// \s matches any whitespace character.
// À-ÿ matches accented characters.
// ,!'&- matches commas, exclamation marks, and ampersands.
const siteDisplayNameRegex = helpers.regex(/^[\w\sÀ-ÿ,!'&@-]+$/);
const deviceOrderPhoneRegex = helpers.regex(/^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/);

export const passwordValidations = {
  required: helpers.withMessage("Required", required),
  minLength: helpers.withMessage(passwordValidationMessage, minLength(8)),
  containsNumber: helpers.withMessage(passwordValidationMessage, containsNumber),
  containsUppercase: helpers.withMessage(passwordValidationMessage, containsUppercase),
  containsLowercase: helpers.withMessage(passwordValidationMessage, containsLowercase),
};

export const siteNameValidator = helpers.withMessage(
  "Site name can only contain letters, number, spaces hyphens and underscores. ",
  siteNameRegex,
);
export const siteDisplayNameValidator = helpers.withMessage(
  "Site display name can only contain letters, number, spaces, hyphens, underscores, commas, exclamation marks, ampersand and @",
  siteDisplayNameRegex,
);

export const requiredField = helpers.withMessage("Required", required);

export const deviceOrderPhone = helpers.withMessage(
  "Please enter a valid phone number",
  deviceOrderPhoneRegex,
);

export const withI18nMessage = (message: string, validator: ValidationRule) =>
  helpers.withMessage(i18n.global.t(message), validator);

export const i18nRequired = withI18nMessage("form.required", required);
